export const WHITELISTED_APPS = [
  'https://explorer.zero.tech',
  'https://z-app-aura.vercel.app',
];
